<div class="modal-backdrop" (click)="dialogRef.close()"></div>
<div class="modal-container">
  <div class="modal">
    <div class="modal-header">
      <h3 class="modal-title">Registrar Atendimento</h3>
    </div>

    <div class="modal-body">
      <form (ngSubmit)="createRegisterCustomerService()" class="card">
        <!-- Assunto -->
        <mat-form-field appearance="outline" floatLabel="always" class="full-width mb-md">
          <mat-label>Assunto</mat-label>
          <input matInput [(ngModel)]="subject" name="subject" #subjectModel="ngModel" required minlength="3" placeholder="Informe o assunto" autofocus />
          <mat-hint align="start" class="text-secondary">Ex.: Dúvida sobre exame, retorno de consulta...</mat-hint>
          <mat-error *ngIf="subjectModel.invalid && subjectModel.touched">
            {{ subjectModel.errors?.['required'] ? 'Assunto é obrigatório.' : 'Assunto deve ter pelo menos 3 caracteres.' }}
          </mat-error>
        </mat-form-field>

        <!-- Categoria -->
        <mat-form-field appearance="outline" floatLabel="always" class="full-width mb-md">
          <mat-label>Categoria</mat-label>
          <mat-select [(ngModel)]="category" name="category" required>
            <mat-option value="duvida">Dúvida</mat-option>
            <mat-option value="suporte">Suporte</mat-option>
            <mat-option value="financeiro">Financeiro</mat-option>
            <mat-option value="outros">Outros</mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Descrição -->
        <mat-form-field appearance="outline" floatLabel="always" class="full-width mb-md">
          <mat-label>Descrição do Atendimento</mat-label>
          <textarea matInput [(ngModel)]="message" name="message" #messageModel="ngModel" required minlength="10" maxlength="500" placeholder="Descreva o atendimento" rows="5"></textarea>
          <mat-hint align="start" class="text-secondary">Inclua detalhes que ajudem no atendimento.</mat-hint>
          <mat-hint align="end">{{ message.length || 0 }}/500</mat-hint>
          <mat-error *ngIf="messageModel.invalid && messageModel.touched">
            {{ messageModel.errors?.['required'] ? 'Descrição é obrigatória.' : 'Descrição deve ter pelo menos 10 caracteres.' }}
          </mat-error>
        </mat-form-field>

        <!-- Urgente -->
        <div class="mb-md">
          <mat-checkbox [(ngModel)]="urgent" name="urgent" color="primary">Marcar como urgente</mat-checkbox>
        </div>
      </form>
    </div>

    <div class="modal-footer">
      <button class="btn btn-ghost" type="button" (click)="dialogRef.close()">Cancelar</button>
      <button class="btn btn-primary" type="submit" (click)="createRegisterCustomerService()" [disabled]="!subjectModel || subjectModel.invalid || !messageModel || messageModel.invalid">
        Registrar
      </button>
    </div>
  </div>
</div>